import { Button } from "primereact/button"
import { useNavigate } from "react-router-dom"

const TemplateButton = ()=>{
    const navigate = useNavigate()

    const handlePage = (e)=>{
        e.preventDefault()
        navigate('/dashboard/template')
    }
    return (
        <Button onClick={handlePage}>Template</Button>
    )
}

export default TemplateButton